<div class="container">
    <div class="row">
        <div class="col section-title-full">
            <h1>
                <span i18n>Ajustes</span>
            </h1>
        </div>
    </div>
</div>

<div class="container p-5">

    <div class="row align-items-center">

        <div class="col">
            <p class="text-destacado text-center" i18n>Aqui puedes cambiar tus preferencias:</p>
        </div>

    </div>

    <div class="card mb-3" *ngIf="applicant?.flags">
        <div class="row">
            <div class="col-sm-4 mb-3">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="email"
                        [(ngModel)]="applicant!.flags!.email" (change)="changeFlag('email')">
                    <label class="form-check-label" for="email" i18n>Recibir notificaciones por
                        email</label>
                </div>
            </div>

            <div class="col-sm-4 mb-3">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="sms"
                        [(ngModel)]="applicant!.flags!.sms" (change)="changeFlag('sms')">
                    <label class="form-check-label" for="sms" i18n>Recibir notificaciones por sms</label>
                </div>
            </div>

            <div class="col-sm-4 mb-3">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="personal"
                        [(ngModel)]="applicant!.flags!.personal">
                    <label class="form-check-label" for="personal" i18n>Consultar datos personales</label>
                </div>
            </div>

            <div class="col-sm-6 mb-3">
                <label for="language" i18n>Idioma notificación: </label>
                <select class="form-select" id="language" [(ngModel)]="applicant!.flags!.language"
                    (change)="changeFlag('language')">
                    <option value="" i18n>Selecciona Idioma</option>
                    <option value="ca-ES" i18n>Catalan</option>
                    <option value="es-ES" i18n>Español</option>
                    <option value="en-GB" i18n>Ingles</option>
                </select>
            </div>

        </div>
    </div>

    <div class="row">
        <div class="col-12 text-center">
            <button type="button" class="btn btn-primary" (click)="save()" i18n>Guardar</button>
        </div>
    </div>
</div>